const paymentRunStyle = {
  container: {
    maxWidth: 1024,
  },
  headline: {
    textAlign: "center",
    fontSize: "2rem",
    fontWeight: 400,
    margin: "2rem 0",
  },
  formPaper: {
    padding: "2rem 5rem",
  },
  textField: {
    backgroundColor: "background.note",
  },
  buttonContainer: {
    margin: "auto",
    maxWidth: 500,
    textAlign: "center",
  },
};

export default paymentRunStyle;
